<template>
  <div class="ml-input-or-text-container" :class="`${disabled?'is-disabled':''}`">
    <el-input
        v-if="editing&&!autoCalc"
        ref="input"
        :value="data"
        :placeholder="placeholder"
        clearable
        :disabled="disabled"
        @blur="handelBlur"
        @input="handelChangeValue($event)"
    >
      <i v-if="prefixIcon" slot="prefix" :class="`el-input__icon iconfont ${prefixIcon}`"/>
      <i v-if="suffixIcon" slot="suffix" :class="`el-input__icon iconfont ${suffixIcon}`"/>
    </el-input>
    <div v-else class="input-val" @click="handelFocus">
      <i v-if="prefixIcon" slot="prefix" :class="`el-input__icon iconfont ${prefixIcon}`"/>
      <span v-if="num" :style="`color:${autoCalc?'#ff3176':''}`">{{ value|numberFormat(2) }}</span>
      <template v-else>{{ value }}</template>
      <i v-if="suffixIcon" slot="suffix" :class="`el-input__icon iconfont ${suffixIcon}`"/>
    </div>
  </div>
</template>
<script>

export default {
  name: "InputOrText",
  props: {
    value: [String, Boolean, Number, Object],
    placeholder: String,
    prefixIcon: {
      type: String,
      default: 'icon-renminbi'
    },
    suffixIcon: String,
    num: Boolean,
    autoCalc: Boolean,
    disabled: Boolean,
  },
  data() {
    return {
      data: null,
      editing: true,
    }
  },
  watch: {
    value: function (_) {
      this.data = _
    },
    data: function (_) {
      this.$emit("update:value", _)
    }
  },
  created() {
    this.data = this.value
    this.setEditing()
  },
  methods: {
    handelFocus: function () {
      if (this.disabled) {
        return;
      }
      this.editing = true
      this.$nextTick(() => {
        this.$refs.input && this.$refs.input.focus()
      })
      this.$emit('tap')
    },
    handelBlur: function () {
      this.setEditing()
    },
    setEditing: function () {
      this.editing = !this.data
    },
    handelChangeValue: function (value) {
      if (!this.num) {
        this.data = value
        return;
      }
      const _val = value.split(',').join('')
      // eslint-disable-next-line no-empty
      if (isNaN(Number(_val))) {

      } else {
        const _indexOf = _val.indexOf('.')
        if (_indexOf >= 0) {
          if (_val.length - 1 - _indexOf <= 2) {
            this.data = _val
          }
        } else {
          this.data = _val
        }
      }
    },
  }
}
</script>
<style lang="scss">
.ml-input-or-text-container {
  width: 100%;

  .input-val {
    width: calc(100% - 12px) !important;
    min-width: unset !important;
    max-width: unset !important;
    overflow-x: hidden;
    text-align: center;
    border: 1px solid rgb(220, 223, 230);
    padding-left: 5px;
    padding-right: 5px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 1em;
    line-height: 26px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;

    i {
      color: rgb(192, 196, 204);
      line-height: 1;
      width: 16px;
    }
  }
}

.ml-input-or-text-container.is-disabled {
  .input-val {
    background-color: #F5F7FA !important;
    border-color: #E4E7ED !important;
    color: #C0C4CC !important;
    cursor: not-allowed !important;
  }
}
</style>
